import React from "react";
import { SigninJoiningAppShell } from "component-library";
import { dataTestIds } from "data-testids";

interface ILayoutProps {
  children: React.ReactNode;
  removePadding?: boolean;
  hideFooter?: boolean;
}

const Layout: React.FC<React.PropsWithChildren<ILayoutProps>> = ({
  children,
  removePadding,
  hideFooter,
}) => (
  <SigninJoiningAppShell
    removePadding={removePadding}
    hideFooter={hideFooter}
    data-testid={dataTestIds.joiningPages["Layout.layout"]}
  >
    {children}
  </SigninJoiningAppShell>
);

export default Layout;
